const DEFAULT_SIGNON_CONTACT = {
  name: 'Laura Dempster',
  email: 'youtheuafc@outlook.com',
  phone: '07432084862',
};

const SLJFC_SIGNON_CONTACT = {
  name: 'Leon Mende',
  email: 'leon@sljfc.co.uk',
  phone: '07854129175',
};

const DEFAULT_SIGNON_CLUB_NAME = 'Eastbourne United AFC';
const SLJFC_SIGNON_CLUB_NAME = 'St Leonards Juniors FC';

export function isSljfcTeamName(teamName) {
  return String(teamName || '').trim().toUpperCase().startsWith('SLJFC');
}

export function isSljfcSignonTeam(teamId, teamName) {
  const id = Number(teamId);
  if ((id >= 251 && id <= 285) || id === 329) {
    return true;
  }
  return isSljfcTeamName(teamName);
}

export function getMembershipSeasonLabel(now = new Date()) {
  const startMonth = 8;
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const startYear = month >= startMonth ? year : year - 1;
  return `Season ${startYear} - ${startYear + 1}`;
}

export function getMembershipSeasonDescription(now = new Date()) {
  const season = getMembershipSeasonLabel(now).replace(/^Season /, 'season ');
  return `A monthly subscription for ${season}. Payment is taken automatically each month.`;
}

export function getSignonQuestionsContact(teamId, teamName) {
  if (isSljfcSignonTeam(teamId, teamName)) {
    return SLJFC_SIGNON_CONTACT;
  }
  return null;
}

export function getSignonClubName(teamId, teamName) {
  if (isSljfcSignonTeam(teamId, teamName)) {
    return SLJFC_SIGNON_CLUB_NAME;
  }
  return null;
}

export function getSignonPhoneHref(phone) {
  const digits = String(phone).replace(/\D/g, '');
  if (digits.startsWith('44')) {
    return `+${digits}`;
  }
  if (digits.startsWith('0')) {
    return `+44${digits.slice(1)}`;
  }
  return `+44${digits}`;
}
